const fromDateString = dateStr => {
  const date = new Date();
  date.setTime(Date.parse(dateStr));

  return date;
};

export default fromDateString;